import styled, { css } from 'styled-components'

import { Box } from '../../../../shared_components/UI/Box'
import { ClaimButton } from '../styles'
import { getRgbaValue } from '../../../../utils/styling'

export const Container = styled(Box)`
  padding: 24px;
  padding-left: 8px;
  gap: 12px;
  height: auto;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: #030b11;
  border-radius: 18px;
  margin: 16px 0 32px;
  flex-wrap: wrap;
  align-items: center;
  z-index: 10;
  @media screen and (max-width: 800px) {
    .inner {
      flex-direction: column;
      align-items: flex-start;
      height: auto;
    }
  }
`

export const InfoSection = styled(Box) <{ isLast?: boolean }>`
  flex-direction: column;
  padding: 0 8px;
  ${({ theme, isLast }) =>
    !isLast &&
    css`
      border-right: 1px solid
        ${getRgbaValue(theme.semantics.zap.surface.primary, 0.1)};
    `}
  span.title {
    font-size: 12px;
    line-height: 15px;
    opacity: 0.6;
    margin-bottom: 8px;
  }
  span.low-opacity {
    opacity: 0.6;
  }
  span.pink {
    color: ${({ theme }) => theme.colors.brandPrimary};
  }
  @media screen and (max-width: 800px) {
    border-right: none;
    margin: 16px auto;
  }
`

export const ClaimableLabel = styled(Box) <{
  isBlue?: boolean
  isGrey?: boolean
}>`
  width: 144px;
  height: 20px;

  justify-content: center;
  align-items: center;
  background: #f4ed0c;
  border-radius: 4px;

  font-family: 'Space Grotesk';
  font-style: normal;
  font-weight: 500;
  font-size: 11px;
  line-height: 12px;

  margin-right: -16px;

  text-transform: uppercase;
  span {
    color: #000000;
  }
  max-height: 20px;
  margin-top: 12px;
  width: auto;
  padding: 0 8px;
  color: white;
  background: ${({ isBlue, isGrey, theme }) =>
    isBlue ? theme.colors.brandSecondary : theme.colors.brandPrimary};
  ${({ isGrey }) =>
    isGrey &&
    css`
      filter: saturate(0);
    `}
`

export const Button = styled(ClaimButton)`
  margin: 0;
  margin-right: 16px;
`

export const PsuedoButton = styled(ClaimableLabel)`
  max-width: 80px;
  font-family: 'Space Grotesk';
  background: #0f0f11;
  font-size: 11px;
  line-height: 12px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.brandPrimary};
  margin-right: 0px;
  margin-top: 0px;
`
